<app-long-card [embedMode]="isEmbedMode">
  <!-- Loading State -->
  <ng-container *ngIf="isLoading">
    <div class="flex flex-col items-center gap-5 py-10">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Validating your link...</p>
    </div>
  </ng-container>

  <!-- Token Error State -->
  <ng-container *ngIf="!isLoading && tokenError">
    <div class="flex flex-col items-center gap-5 py-5">
      <mat-icon class="error-icon">error</mat-icon>
      <h3 class="error-title">Link Invalid or Expired</h3>
      <p class="text-center px-4">{{ tokenError }}</p>
      <div class="flex flex-row justify-center items-center gap-3 mt-4">
        <button mat-raised-button color="primary" (click)="requestNewLink()">
          Request New Link
        </button>
        <button mat-stroked-button (click)="goToHome()">
          Back to Home
        </button>
      </div>
    </div>
  </ng-container>

  <!-- Valid Token - Show Form -->
  <ng-container *ngIf="!isLoading && !tokenError">
    <ng-container *ngIf="!processComplete; else completedBlock">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <h3>Change Password</h3>
        <br />

        <div class="flex flex-col">
          <div class="flex-[50%] mb-30">
            <mat-form-field
              class="form-group"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label>New Password</mat-label>
              <input
                [type]="hide ? 'password' : 'text'"
                class="form-control"
                matInput
                formControlName="usrPassword"
              />
              <mat-icon matSuffix (click)="hide = !hide" class="pointer">{{
                hide ? "visibility_off" : "visibility"
              }}</mat-icon>
            </mat-form-field>
          </div>
          <br />
          <div class="flex-[50%]">
            <mat-form-field
              class="form-group"
              appearance="outline"
              floatLabel="always"
            >
              <mat-label>Confirm Password</mat-label>
              <input
                [type]="hide ? 'password' : 'text'"
                class="form-control"
                matInput
                formControlName="usrPassword_confirmation"
              />
              <mat-icon matSuffix (click)="hide = !hide" class="pointer">{{
                hide ? "visibility_off" : "visibility"
              }}</mat-icon>
            </mat-form-field>
          </div>
        </div>
        <br />
        <div class="flex flex-col text-left">
          <label
            [ngClass]="
              form.controls['usrPassword'].hasError('required') ||
              form.controls['usrPassword'].hasError('minlength')
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              form.controls["usrPassword"].hasError("required") ||
              form.controls["usrPassword"].hasError("minlength")
                ? "cancel"
                : "check_circle"
            }}</i>
            Must be at least 8 characters!
          </label>
          <label
            [ngClass]="
              form.controls['usrPassword'].hasError('required') ||
              form.controls['usrPassword'].hasError('hasNumber')
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              form.controls["usrPassword"].hasError("required") ||
              form.controls["usrPassword"].hasError("hasNumber")
                ? "cancel"
                : "check_circle"
            }}</i>
            Must contain at least 1 number!
          </label>
          <label
            [ngClass]="
              form.controls['usrPassword'].hasError('required') ||
              form.controls['usrPassword'].hasError('hasCapitalCase')
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              form.controls["usrPassword"].hasError("required") ||
              form.controls["usrPassword"].hasError("hasCapitalCase")
                ? "cancel"
                : "check_circle"
            }}</i>
            Must contain at least 1 in Capital Case!
          </label>
          <label
            [ngClass]="
              form.controls['usrPassword'].hasError('required') ||
              form.controls['usrPassword'].hasError('hasSmallCase')
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              form.controls["usrPassword"].hasError("required") ||
              form.controls["usrPassword"].hasError("hasSmallCase")
                ? "cancel"
                : "check_circle"
            }}</i>
            Must contain at least 1 Letter in Small Case!
          </label>
          <label
            [ngClass]="
              form.controls['usrPassword'].hasError('required') ||
              form.controls['usrPassword'].hasError('hasSpecialCharacters')
                ? 'text-danger'
                : 'text-success'
            "
          >
            <i class="material-icons">{{
              form.controls["usrPassword"].hasError("required") ||
              form.controls["usrPassword"].hasError("hasSpecialCharacters")
                ? "cancel"
                : "check_circle"
            }}</i>
            Must contain at least 1 Special Character!
          </label>
        </div>
        <br />
        <button
          type="submit"
          mat-raised-button
          [disabled]="!form.valid == true"
          color="primary"
          class="w-full flex justify-center"
        >
          Update Password
        </button>
      </form>
    </ng-container>
    <ng-template #completedBlock>
      <div class="flex flex-col items-center gap-5">
        <!-- New sign-up (embed mode) -->
        <ng-container *ngIf="isEmbedMode; else regularReset">
          <h3 class="mb-30">You're ready to start using trakr!</h3>
          <div class="flex flex-row justify-center items-center gap-3 mt-20">
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="goToLogin()"
            >
              Login
            </button>
            <button
              type="button"
              mat-stroked-button
              (click)="goToHome()"
            >
              Back to Home
            </button>
          </div>
        </ng-container>

        <!-- Regular password reset -->
        <ng-template #regularReset>
          <h3 class="mb-30">Password has been changed!</h3>
          <div class="mt-30 mb-20 pl-20 pr-20">
            If you are a <strong>Counter</strong> return to the app on your mobile
            device.
          </div>
          <div class="flex flex-col">
            <div class="mb-20">
              If you are an <strong>Admin</strong> click the login button below.
            </div>
            <div class="flex flex-row justify-center items-center">
              <div class="maxw-100">
                <button
                  type="button"
                  mat-raised-button
                  color="primary"
                  (click)="goToLogin()"
                  class="w-full flex justify-center"
                >
                  Login
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </ng-container>
</app-long-card>
